































import {Vue, Component} from 'vue-property-decorator'
import OrbitLeaderboardScrollableTable from '@/components/orbit/OrbitLeaderboardScrollableTable.vue'
import FilterLeaderboardOrbit from '@/components/filters/FilterLeaderboardOrbit.vue'
import OrbitLeaderboardPagination from '@/components/orbit/OrbitLeaderboardPagination.vue'
import {OrbitLeaderboardCollection} from '@/model/collection/OrbitLeaderboardCollection'

@Component({
  components: {
    OrbitLeaderboardPagination,
    FilterLeaderboardOrbit,
    OrbitLeaderboardScrollableTable,
  },
})
export default class OrbitLeaderboardContent extends Vue {
  periodOptions = ['Now', '1d', '7d', '14d', '30d', 'All-time']
  selectedPeriod = '1d'
  currentPage = 1
  pageSize = 10
  approvedOnly = true

  collection = new OrbitLeaderboardCollection()

  mounted() {
    this.populateResources()
  }

  get hasNextPage() {
    return this.currentPage * this.pageSize < (this.collection.total ?? 0)
  }

  get hasPreviousPage() {
    return this.currentPage > 1
  }

  get isOnFirstPage() {
    return this.currentPage <= 1
  }

  handleSelectPeriod(option: string) {
    this.selectedPeriod = option
    this.currentPage = 1
    this.populateResources()
  }

  handleFirstPage() {
    if (this.isOnFirstPage) return
    this.currentPage = 1
    this.populateResources()
  }

  handlePreviousPage() {
    if (!this.hasPreviousPage) return
    this.currentPage -= 1
    this.populateResources()
  }

  handleNextPage() {
    if (!this.hasNextPage) return
    this.currentPage += 1
    this.populateResources()
  }

  applyCollection() {
    this.collection.period = this.mapPeriodToApi(this.selectedPeriod)
    this.collection.limit = this.pageSize
    this.collection.page = this.currentPage - 1
    this.collection.orderBy = 'totalTxs'
    this.collection.ascending = false
    this.collection.approvedOnly = this.approvedOnly
  }

  async populateResources() {
    this.$await.init('populateLeaderboard')
    this.applyCollection()

    try {
      await this.collection.queryAsPage()
    } finally {
      this.$await.done('populateLeaderboard')
    }
  }

  mapPeriodToApi(period: string) {
    const normalized = period.trim().toLowerCase()
    if (normalized === 'all-time') return 'all-time'
    if (normalized === 'now') return 'now'
    return normalized
  }
}
